/**
 * @param {FormApi} form
 */
export function createLoadingDecorator(form) {
  return form.subscribe(
    ({ submitting }) => {
      const button = document.querySelector('.bfe-submit');
      const container = document.querySelector('.bfe-form');
      const input = document.getElementById('bfe-email');

      if (submitting) {
        button.disabled = true;
        input.disabled = true;
        container.classList.add('submitting');
      } else {
        button.disabled = false;
        input.disabled = false;
        container.classList.remove('submitting');
      }
    },
    {
      submitting: true,
    },
  );
}
